import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const SoftwareDevelopment = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="Software Development Services" 
      subtitle="YAYOU INFORMATION TECHNOLOGY offers end-to-end software engineering services with on-demand resources for full-scale enterprise digital transformation and comprehensive managed IT solutions."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Enterprise Digital Transformation</h2>
            <p>
              We provide comprehensive software engineering services and managed IT solutions, offering on-demand resources for full-scale enterprise digital transformation and product development with cutting-edge technologies.
            </p>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Managed IT Services</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We provide a full scope of managed IT services designed to minimize management workload for customers while ensuring seamless integration of specialists into in-house IT teams.
                  </p>
                  
                  <div className="info-section">
                    <h4>Service Portfolio</h4>
                    <ul>
                      <li>Full scope of managed IT services delivery</li>
                      <li>Minimized management workload for customers</li>
                      <li>Integration of specialists into in-house IT teams</li>
                      <li>Implementation of relevant methodologies</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Technical Expertise</h4>
                    <ul>
                      <li>End-to-end software engineering services</li>
                      <li>On-demand technical resource allocation</li>
                      <li>Comprehensive IT infrastructure management</li>
                      <li>24/7 technical support and monitoring</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/managed_it_solution.png" 
                    alt="Managed IT Services" 
                    onClick={() => openLightbox('/images/managed_it_solution.png', 'Managed IT Services')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Application Development & Modernization</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We deliver comprehensive web, mobile and cloud applications from scratch or on leading tech platforms, including legacy system modernization and architecture enhancement services.
                  </p>
                  
                  <div className="info-section">
                    <h4>Application Development</h4>
                    <ul>
                      <li>Web, mobile and cloud apps delivery</li>
                      <li>Custom applications from scratch development</li>
                      <li>Leading tech platforms integration</li>
                      <li>Configuration, testing, and employee onboarding</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Legacy System Modernization</h4>
                    <ul>
                      <li>Redesign and refactoring of outdated systems</li>
                      <li>Code refactoring and optimization</li>
                      <li>Migration to modern platforms and architectures</li>
                      <li>Comprehensive architecture reviews and assessments</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/application_development_modernization.png" 
                    alt="Application Development" 
                    onClick={() => openLightbox('/images/application_development_modernization.png', 'Application Development')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Advanced Security Solutions</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We implement comprehensive security solutions including Secure Access Service Edge (SASE), network security in the cloud, and advanced threat detection functions for enterprise protection.
                  </p>
                  
                  <div className="info-section">
                    <h4>Security Architecture</h4>
                    <ul>
                      <li>Secure Access Service Edge (SASE) implementation</li>
                      <li>Network Security in the Cloud deployment</li>
                      <li>Firewall as a Service (FWaaS) solutions</li>
                      <li>Secure Web Gateway (SWG) integration</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Advanced Protection</h4>
                    <ul>
                      <li>Zero-Trust Network Access (ZTNA) implementation</li>
                      <li>Advanced threat detection and response functions</li>
                      <li>Comprehensive security monitoring and analytics</li>
                      <li>Enterprise-grade vulnerability management</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/advanced_security_solutions.png" 
                    alt="Security Solutions" 
                    onClick={() => openLightbox('/images/advanced_security_solutions.png', 'Security Solutions')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Transform Your Digital Infrastructure</h3>
            <p>Ready to modernize your enterprise with cutting-edge software solutions? Contact our development specialists.</p>
            <a href="/contact" className="btn immigration-btn-primary">Start Your Project</a>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default SoftwareDevelopment;